import React, { useCallback, useEffect, useState } from "react";
import { getDashboardStats, getMe, getPools } from "@/lib/api";
import { useWallet } from "@/context/WalletContext";
import WelcomeStatus from "@/components/WelcomeStatus";
import ReferralCard from "@/components/ReferralCard";
import GlobalBusiness from "@/components/GlobalBusiness";
import MyBusiness from "@/components/MyBusiness";
import TeamReward from "@/components/TeamReward";
import RecentActivity from "@/components/RecentActivity";
import TopHolders from "@/components/TopHolders";

export default function Dashboard({ onNavigate }) {
  const { isConnected, address, user } = useWallet();
  const [stats, setStats] = useState(null);
  const [me, setMe] = useState(null);
  const [pools, setPools] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    getDashboardStats()
      .then((d) => {
        setStats(d);
        setError(false);
      })
      .catch(() => setError(true));
    if (address) {
      getMe(address).then(setMe).catch(() => setMe(null));
      getPools(address).then(setPools).catch(() => setPools(null));
    } else {
      setMe(null);
      setPools(null);
    }
  }, [address]);

  useEffect(() => {
    load();
  }, [load, user?.is_active]);

  if (error) {
    return (
      <div data-testid="dashboard-error" className="px-4 py-10 text-center text-sm text-white/50">
        Unable to load protocol data. Please retry.
      </div>
    );
  }

  return (
    <div data-testid="dashboard" className="flex flex-col gap-4 px-4 pt-4">
      <WelcomeStatus stats={stats} me={me} onNavigate={onNavigate} />
      <ReferralCard me={me} />
      <GlobalBusiness stats={stats} me={me} pools={pools} />
      <MyBusiness me={me} />
      <TeamReward me={me} />
      <RecentActivity me={me} />
      <TopHolders />
    </div>
  );
}
